module.exports = __webpack_public_path__ + "static/console-83835340c673cfc5a596be4272d7e652.mp4";